interface SpinnerProps {
  size?: "sm" | "lg";
  label?: string;
}

export function Spinner({ size = "sm", label }: SpinnerProps) {
  return (
    <span className={`spinner ${size === "lg" ? "spinner--lg" : ""}`} role="status" aria-label={label ?? "Loading"} />
  );
}

export function LoadingBlock({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="center-pad">
      <Spinner size="lg" />
      <span>{label}</span>
    </div>
  );
}
